module.exports = __webpack_public_path__ + "img/next-era-white.b1f28a7c.png";